import { useMemo } from "react";

export function useMinMax(data: (string | number)[]): [number, number] {
  return useMemo(
    () =>
      data.reduce(
        ([min, max], val) => [
          Math.min(min, Number(val)),
          Math.max(max, Number(val)),
        ],
        [Number.POSITIVE_INFINITY, Number.NEGATIVE_INFINITY]
      ),
    [data]
  );
}
